module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step2-pict03-full-3d32cab7d175f64e0a8381c6383259de.jpg";